import React from 'react';
import { useState,useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { deleteProviderById} from '../../../../../../../../crud/management_api/providers';


const DeleteProvider: React.FC<any> =  ({
      showDeleteModal,
      setShowDeleteModal,
      currentProvider,
      currentData,
      setCurrentData
    }
    ) => {
      const handleDeleteProvider = async () => {
        if (currentProvider) {
          try {
           const isSuccess = await deleteProviderById(Number(currentProvider.provider_id));
            if (isSuccess) {
              toast.success('Proveedor eliminado con éxito!');
                const updatedData = currentData.filter((provider:any) => provider.provider_id !== currentProvider.provider_id);
                setCurrentData(updatedData);
            } else {
              console.error('Error al eliminar proveedor');
              toast.error('Error al eliminar proveedor');
            }
          } catch (error) {
            console.error('Error al eliminar proveedor', error);
            toast.error('Error al eliminar proveedor');
          }
          setShowDeleteModal(false);
        }
      };
      return (
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header >
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Confirmar eliminación</Modal.Title>
        </div>
          <Button variant="none" className="modal-close-button" onClick={() => setShowDeleteModal(false)}>
            <X size={24} /> 
          </Button>
        </Modal.Header>
        <Modal.Body>Estás seguro de que quieres eliminar este proveedor?</Modal.Body>
        <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button className="form-button-cancel" onClick={() => setShowDeleteModal(false)}>Cancelar</Button>
          <Button className="form-button-create" onClick={handleDeleteProvider}>Eliminar</Button>
        </div>
        </Modal.Footer>
      </Modal>
    )};

export default DeleteProvider;